import { create } from "zustand";

interface ResourceState {
  // Available options
  sortingOptions: string[];
  setSortingOptions: (newFilters: string[]) => void;
  sortingOption: string;
  setSortingOption: (newFilters: string) => void;

  typeFilterOptions: string[];
  setTypeFilterOptions: (newFilters: string[]) => void;

  // Active filters
  filters: {
    type: string[];
    searchQuery: string;
  };

  // Actions
  setFilter: (
    key: keyof ResourceState["filters"],
    value: string[] | string,
  ) => void;
  resetFilters: () => void;
  toggleFilterItem: (
    key: keyof ResourceState["filters"],
    value: string,
  ) => void;
  clearFilter: (key: keyof ResourceState["filters"]) => void;
}

const useFilterStore = create<ResourceState>((set) => ({
  // Available options
  sortingOptions: ["Upcoming events", "Recently added"],
  setSortingOptions: (newFilters) => set({ sortingOptions: newFilters }),

  sortingOption: "Upcoming events",
  setSortingOption: (newOption) => set({ sortingOption: newOption }),

  typeFilterOptions: ["In-Person", "Webinars", "Partner Events", "Virtual"],
  setTypeFilterOptions: (newFilters) => set({ typeFilterOptions: newFilters }),

  // Active filters
  filters: {
    type: [],
    searchQuery: "",
  },

  // Actions
  // Set a specific filter
  setFilter: (key, value) =>
    set((state) => ({
      filters: { ...state.filters, [key]: value },
    })),

  // Reset all filters
  resetFilters: () =>
    set({
      filters: { type: [], searchQuery: "" },
    }),

  // Toggle an item in an array filter (sorting or type)
  toggleFilterItem: (key: keyof ResourceState["filters"], value: string) =>
    set((state) => {
      const currentValues = state.filters[key];

      // Check if the value is an array
      if (Array.isArray(currentValues)) {
        const updatedValues = currentValues.includes(value)
          ? currentValues.filter((item) => item !== value)
          : [...currentValues, value];
        return {
          filters: {
            ...state.filters,
            [key]: updatedValues,
          },
        };
      }

      return state;
    }),

  // Clear a specific filter (e.g., sorting or type)
  clearFilter: (key) =>
    set((state) => ({
      filters: { ...state.filters, [key]: key === "searchQuery" ? "" : [] },
    })),
}));

export default useFilterStore;
